import { useStore } from 'effector-react'
import { Sorting } from 'features/cars-list/types'
import { createMediaStyles } from 'lib/styled-helpers'
import React, { FC } from 'react'
import styled from 'styled-components'

import { getProjectName } from '../../../lib/get-project-name'
import { Select } from '../../../ui/select'
import { SelectOptionProps } from '../../../ui/select/types'
import { $sorting, setSort } from '../model'

type Props = Sorting

export const SortASP: FC<Props> = ({ text, options }) => {
  let sortList: SelectOptionProps[] = []
  options.map((item) => {
    sortList.push({ label: item.label, value: item.key, active: item.active })
  })

  const sorting = useStore($sorting)

  return (
    <Wrapper>
      <Select
        value={(sorting.sort + '_' + sorting.order) as string}
        options={sortList}
        label={text}
        onChange={(value) => setSort(value)}
        open={false}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.textStyles.p2};
  background: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return theme.palette?.black
    return theme.palette.white
  }};
  color: ${({ theme }) => theme.palette.grey[500]};
  border-radius: ${() => getProjectName() === 'avito' && '12px'};

  ${createMediaStyles(() => ({
    tablet: `border-top: 0; justify-content: flex-start;`
  }))}

  input {
    border-width: 0;
  }
`
